$(document).ready(function () {
    console.log('hello JS loaded');

    if( document.location.host == 'www.lakai.com' ) {
        console.log('USA Store Welcome');
        console.log($('#lakai-crew-cta-footer'));
        console.log($('#lakai-crew-cta-footer').css('display', 'none'));
        $('#lakai-crew-cta-footer').css('display', 'none');
    }
    // CODE ONLY ABOVE THIS LINE AS DOCOMENT.READY ENDS HERE
});